import dottie from 'dottie'

import {
  get,
  ApiResponse,
  ApiResponseData,
} from 'utils/apis/insuranceLounge'
import {
  GenericAction,
  CacheResponse,
} from 'state/types'
import {
  ActionTypes,
  VehicleSubmodels,
} from 'state/vehicleAttributes/submodels/types'

interface RawApiSubmodel {
  partial_vin: string,
  submodel: string,
}

const {
  CACHE_SUBMODELS_BEGIN,
  CACHE_SUBMODELS_SUCCESS,
  CACHE_SUBMODELS_FAILURE,
} = ActionTypes

const fetchVehicleSubmodels = async (year: string | number, make: string, model: string): Promise<RawApiSubmodel[]> => {
  const vehicleSubmodels: ApiResponse = await get(`/vehicle-attributes/years/${year}/makes/${make}/models/${model}/submodels`)

  if (!vehicleSubmodels.success) {
    throw vehicleSubmodels
  }

  return vehicleSubmodels.data as RawApiSubmodel[]
}

// eslint-disable-next-line import/prefer-default-export
export const cacheVehicleSubmodels = (year: string, make: string, model: string) => async (
  dispatch: Function,
  getState: Function,
): CacheResponse => {
  if (
    dottie.get(
      getState(),
      [
        'vehicleAttributes',
        'submodels',
        year,
        make,
        model,
        'cached',
      ],
    )
  ) {
    return true
  }

  dispatch(cacheVehicleSubmodelsBegin(year, make, model))

  return await fetchVehicleSubmodels(year, make, model)
    .then(vehicleSubmodels => {
      const keyedVehicleSubmodels: VehicleSubmodels = {}
      if (vehicleSubmodels) {
        vehicleSubmodels.map(({
          submodel,
          partial_vin: partialVin,
        }: RawApiSubmodel) => {
          keyedVehicleSubmodels[submodel] = {
            submodel,
            partialVin,
          }
        })
      }

      dispatch(
        cacheVehicleSubmodelsSuccess(
          year,
          make,
          model,
          keyedVehicleSubmodels,
        ),
      )
    })
    .catch((error: Error) => {
      dispatch(cacheVehicleSubmodelsFailure(year, make, model, error))

      return Promise.reject(error.message || 'Unable to cache vehicle submodels.')
    })
}

const cacheVehicleSubmodelsBegin = (year: string, make: string, model: string): GenericAction => ({
  type: CACHE_SUBMODELS_BEGIN,
  payload: {
    year,
    make,
    model,
  },
})

const cacheVehicleSubmodelsSuccess = (year: string, make: string, model: string, submodels: VehicleSubmodels): GenericAction => ({
  type: CACHE_SUBMODELS_SUCCESS,
  payload: {
    year,
    make,
    model,
    submodels,
  },
})

const cacheVehicleSubmodelsFailure = (year: string, make: string, model: string, error: ApiResponseData): GenericAction => ({
  type: CACHE_SUBMODELS_FAILURE,
  payload: {
    year,
    make,
    model,
    error,
  },
})
